<template>
  <div id="air_temperature_ship">
    <div 
      v-if="receivedData"
    >
      <TabsCustomGraphic 
        :received-data="receivedData"
        id="air_temperature"
      />
    </div>  
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'AirTemperature',
  components: {
    TabsCustomGraphic: () => import('@/components/graph/TabsCustomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'air_temperature',
      cloneElementId: 'air_temperature_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '19,20,21,22,23').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>